// Composes a client contact's display name as "first last" (either part may be missing),
// trimmed. Returns '' when there is no contact OR the contact has no name — callers decide
// how to present an empty result (e.g. "None Set" in the invoice list, client name alone in
// the PDF). Unlike DataExportFormatter._fullname, this never renders a null part as "null".
export const composeClientContactName = (contact?: {firstName?: string | null; lastName?: string | null} | null): string =>
	contact ? `${contact.firstName ?? ''} ${contact.lastName ?? ''}`.trim() : '';
